import Request from './request'

const Devices = {
  getDevices (page, params, callback) {
    Request.post('devices/' + page, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDevicesCSV (params, callback) {
    Request.post('devices/as-csv', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getModelsDevices (callback){
    Request.get('devices/models-list').then(callback).catch(this.bad_answer)
  },
  getFirmWareVersions(callback){
    Request.get('devices/firmware-versions').then(callback).catch(this.bad_answer)
  },
}
export default Devices
